import styled from "styled-components";
import { Button } from "antd";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 186px;
  gap: 15px;
  padding: 0em 8em 3em 8em;
`;

export const HeadingsContiner = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr 1fr;
  align-items: center;
  background-color: #ffcc74;
  min-width: 1180.77px;
  min-height: 116.31px;
  align-items: center;
`;

export const Heading = styled.h4`
  font-size: 24px;
  font-family: Poppins-Light;
  color: #1d1d1d;
  text-align: center;
`;

export const EquipmentContainer = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr 1fr;
  justify-items: center;
  background-color: #fef5ea;
  min-width: 1180.77px;
  min-height: 116.31px;
  align-items: center;
`;

export const Line = styled.hr`
  color: red;
  border-top: dashed 1px;
`;

export const ConditionButton = styled(Button)`
  background-color: #4ed128;
  width: 142px;
  height: 60px;
  border-radius: 9px;
  font-size: 25px;
  font-family: "Poppins-Light";
  :hover {
    background-color: #4ed128;
    width: 142px;
    height: 60px;
    border-radius: 9px;
    font-size: 25px;
    font-family: "Poppins-Light";
    color: #1d1d1d;
    border: none;
  }
`;
